<!-- <drx-ui-topbar [navbarOption]="navbarOption">
  <div drx-ui-nav-items [navItems]="navItems" class="m-auto"></div>

  <div class="ms-auto mt-2 mb-2">
    <button
      class="btn btn-primary"
      style="float: right"
      (click)="loggedIn ? logout() : login()"
    >
      {{ loggedIn ? "Logout" : "Login" }}
    </button>
  </div>
</drx-ui-topbar> -->
<mat-toolbar class="flex items-center top-0 fixed z-100" color="primary">
  <img class="max-[500px]:size-16 logo-image px-1" alt="DRÄXLMAIER LOGO" src="img/drx-logo-white.svg" />
  <div class="flex items-center">
    <span class="max-[1030px]:text-xs max-[1300px]:text-sm text-wrap p-6">Utility App</span>
  </div>
  <div class="max-[1025px]:hidden min-[1200px]:px-52 text-wrap">
    @for (item of navItems; track $index) {
    <button mat-button class="max-[1025px]:invisible" [routerLink]="[item.link]" title="{{ item.text }}">
      {{ item.text }}
    </button>
    }
  </div>
  <div class="ms-auto grid grid-flow-col auto-cols-min">
    <div class="ms-auto items-center">
      <span>
        @if(loggedIn) {
        <button matButton="elevated" (click)="logout()">
          Logout
        </button>
        } @else {
        <button matButton="elevated" (click)="login()">Login</button>
        }
      </span>
    </div>
    <div class="ms-auto items-center min-[1025px]:hidden">
      <span>
        <button mat-icon-button (click)="toggleMenu()">
          <mat-icon>menu</mat-icon>
        </button>
      </span>
    </div>
  </div>
</mat-toolbar>

<div class="mt-[64px] flex flex-col px-4 pb-4 min-[1025px]:hidden" *ngIf="triggerMenu">
  <div class="menu-container border-b-2 divide-y-2 ">
    @for (item of navItems; track $index) {
    <div>
      <button mat-button class="menu-buttons text-wrap px-2" [routerLink]="[item.link]" title="{{ item.text }}">
        {{ item.text }}
      </button>
    </div>
    }
  </div>
</div>
<div class="mt-[64px] left-0 right-0 min-h-[calc(100vh-64px)]">
  <div class="h-full w-full bg-light">
    <router-outlet></router-outlet>
  </div>
</div>